import React, { useState, useEffect } from 'react';
import { Page, ButtonArea, Icon, Form, Toast, FormCell,CellBody,CellFooter, Select, Dialog, CellHeader, Label, Input, Button } from 'react-weui';
import {  postBindCard, queryOfficeList, queryUserList } from '@/services/myself';
import { history } from 'umi';

import { getLoginUser } from '@/utils/login';
import { setUser } from '@sentry/react';

const sortOfficeByName = (officeList) => {
  return officeList.filter(t => t.name).sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
}

export default (props) => {
  // const [name, setName] = useState('');
  // const [mobile, setMobile] = useState('');
  // const [vscode, setVscode] = useState('');
  // const [buttonMessage, setButtonMessage] = useState('发送验证码');
  // const [buttonClickable, setButtonClickable] = useState(true);
  const [isRequest, setIsRequest] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isShowError, setIsShowError] = useState(false);
  const [isMemberShow, setIsMemberShow] = useState(false);
  const [cardNo, setCardNo] = useState('');
  const [officeId, setOfficeId] = useState('');
  const [userId, setUserId] = useState('');
  const [officeList, setOfficeList] = useState([]);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    const currentUser = getLoginUser();
    if (currentUser && currentUser.commonid) {
      setIsMemberShow(false);
    } else {
      setIsMemberShow(true);
    }

    queryOfficeList({}).then(res => {
      if (res.code === 200) {
        const tmpOfficeList = sortOfficeByName(res.data);
        setOfficeList(tmpOfficeList);
        if (tmpOfficeList.length > 0) {
          setOfficeId(tmpOfficeList[0].id);
        }
      }
    });

    queryUserList({}).then(res => {
      if (res.code === 200) {
        setUserList(res.data);
      }
    });

  }, []);

  // const sendVscode = () => {
  //   updateButtonMessage(59);
  //   getSendCode({mobile}).then(res => {
  //     if (res && res.code === 200) {
  //       setIsSuccess(true);
  //       setTimeout(() => setIsSuccess(false), 3000);
  //     } else {
  //       setIsShowError(true);
  //       setErrorMessage(res.message);
  //     }
  //   })
  // }

  const submitForm = () => {
    postBindCard({
      officeId,
      userId,
      cardNo,
    }).then(res => {
      if (res.code === 200) {
        setIsSuccess(true);
        // history.push('/nav/myself');
        setTimeout(() => history.goBack(), 1000);
        setTimeout(() => setIsSuccess(false), 3000);
      } else {
        setIsShowError(true);
        setErrorMessage(res.message);
      }
    }).finally(() => setIsRequest(false));
  }

  // const updateButtonMessage = (seconds) => {
  //   if (seconds <= 0) {
  //     setButtonClickable(true);
  //     setButtonMessage('发送验证码');
  //   } else {
  //     setButtonClickable(false);
  //     setButtonMessage(`${seconds}s后重新获取`);
  //     setTimeout(() => updateButtonMessage(seconds - 1), 1000);
  //   }
  // }

  return (

    <Page className="input" title="Input" subTitle="表单输入" spacing>
      {/*<CellsTitle>Forms</CellsTitle>*/}
      <div style={{marginLeft: '10px'}} className="page__hd">
        <h1 className="page__title"></h1>
        {/*<p className="page__desc"></p>*/}
      </div>
      <Form>
        {/*<FormCell>*/}
        {/*  <CellHeader>*/}
        {/*    <Label>姓名</Label>*/}
        {/*  </CellHeader>*/}
        {/*  <CellBody>*/}
        {/*    <Input value={name} maxLength={20} onInput={e => setName(e.target.value) } placeholder="请输入姓名"/>*/}
        {/*  </CellBody>*/}
        {/*</FormCell>*/}

        <FormCell>
          <CellHeader>
            <Label>幸福卡号</Label>
          </CellHeader>
          <CellBody>
            <Input value={cardNo} maxLength={30} onInput={e => setCardNo(e.target.value) } placeholder="请输入幸福卡号"/>
          </CellBody>
        </FormCell>

        <FormCell select selectPos="after">
          <CellHeader>
            <Label>选择门店</Label>
          </CellHeader>
          <CellBody>
            <Select
              value={officeId}
              onChange={e => {
                const tmpId = e.target.value;
                setOfficeId(tmpId);
                const tmpList = userList.filter(t => t.shopId && t.shopId === tmpId);
                if (tmpList.length > 0) {
                  setUserId(tmpList[0].id);
                } else {
                  setUserId('');
                }
              }}
              data={officeList.map(item => ({
                value: item.id,
                label: item.name,
              }))}
            />
          </CellBody>
        </FormCell>

        <FormCell select selectPos="after">
          <CellHeader>
            <Label>选择员工</Label>
          </CellHeader>
          <CellBody>
            <Select
              value={userId}
              onChange={e => setUserId(e.target.value)}
              data={ officeId ? userList.filter(
              t => t.shopId && t.shopId === officeId
            ).map(item => ({
              value: item.id,
              label: item.name,
            })) : [] } />
          </CellBody>
        </FormCell>

        {/*<FormCell warn={mobile && !/^\d{11}$/.test(mobile)}>*/}
        {/*  <CellHeader>*/}
        {/*    <Label>手机号码</Label>*/}
        {/*  </CellHeader>*/}
        {/*  <CellBody>*/}
        {/*    <Input value={mobile} maxLength={11} onInput={e => setMobile(e.target.value) } type="tel" placeholder="请输入手机号码"/>*/}
        {/*  </CellBody>*/}
        {/*  <CellFooter>*/}
        {/*    <Icon value="warn" />*/}
        {/*  </CellFooter>*/}
        {/*</FormCell>*/}
        {/*<FormCell vcode>*/}
        {/*  <CellHeader>*/}
        {/*    <Label>验证码</Label>*/}
        {/*  </CellHeader>*/}
        {/*  <CellBody>*/}
        {/*    <Input value={vscode} maxLength={6} onInput={e => {*/}
        {/*      const value = e.target.value;*/}
        {/*      value <= 999999 ? setVscode(value) : null;*/}
        {/*    }} type="number" placeholder="请输入验证码"/>*/}
        {/*  </CellBody>*/}
        {/*  <CellFooter>*/}
        {/*    <Button disabled={ !/^\d{11}$/.test(mobile) || !buttonClickable } onClick={() => {*/}
        {/*      sendVscode();*/}
        {/*    }} type="vcode">{buttonMessage}</Button>*/}
        {/*  </CellFooter>*/}
        {/*</FormCell>*/}
      </Form>
      {/*<CellsTips>Form Footer Tips</CellsTips>*/}

      <ButtonArea>
        <Button
          onClick={() => {
            setIsRequest(true);
            submitForm();
          }}
          disabled={!(cardNo && cardNo.length >= 5) }>
          提交
        </Button>
      </ButtonArea>

      <Dialog type="ios" title={'请求失败'} buttons={[
        {
          label: '确定',
          onClick: () => setIsShowError(false) && setErrorMessage(null),
        }
      ]} show={isShowError}>
        { errorMessage || '请求后台数据失败'}
      </Dialog>

      <Toast icon="success-no-circle" show={isSuccess}>请求成功</Toast>
      <Toast icon="loading" show={isRequest}>加载中...</Toast>

      <Dialog type="ios" title={'提示信息'} buttons={[{
        label: '返回',
        onClick: () => history.goBack(),
      }]} show={isMemberShow}>
        您还未开通会员，需要先开通会员。
      </Dialog>

    </Page>
  )


}

